export const VIDEO_BOOKEND_PRESETS = [{
  id: 'haochen-pearl-cadence-v5',
  label: '灏尘说 · 主题收束版',
  duration_seconds: { opening: 5.4, ending: 10.4 },
  description: { opening: '珍珠白与哑金标识，短钢琴主题配稀疏伴奏，随尾音渐出。', ending: '独立完整的收束演奏，短主题以较低的乐句回应，结束和弦逐渐消失。' },
  has_audio: true,
  poster_url: '/api/video-bookends/haochen-cadence-v5.png',
  opening_url: '/api/video-bookends/haochen-intro-melody-v4.mp4',
  ending_url: '/api/video-bookends/haochen-outro-cadence-v5-clean.mp4',
}, {
  id: 'haochen-pearl-melody-v4',
  label: '灏尘说 · 清晰主题版',
  duration_seconds: { opening: 5.4, ending: 9.4 },
  description: { opening: '珍珠白与哑金标识，短钢琴主题配稀疏伴奏，随尾音渐出。', ending: '沿用片头的同一演奏主题，重复后逐渐减弱，标识随尾音回到黑场。' },
  has_audio: true,
  poster_url: '/api/video-bookends/haochen-melody-v4.png',
  opening_url: '/api/video-bookends/haochen-intro-melody-v4.mp4',
  ending_url: '/api/video-bookends/haochen-outro-melody-v4.mp4',
}, {
  id: 'haochen-pearl-performance-v3',
  label: '灏尘说 · 珍珠白金演奏版',
  duration_seconds: { opening: 5.4, ending: 10.4 },
  description: { opening: '原版珍珠白与哑金标识，配器乐演奏，清晰停留 3 秒后随尾音渐出。', ending: '原版珍珠白与哑金标识，较长的收束演奏渐弱至静音，标识随尾音回到黑场。' },
  has_audio: true,
  poster_url: '/api/video-bookends/haochen-performance-v3.png',
  opening_url: '/api/video-bookends/haochen-intro-performance-v3.mp4',
  ending_url: '/api/video-bookends/haochen-outro-performance-v3.mp4',
}, {
  id: 'haochen-color-sound-v2',
  label: '灏尘说 · 彩色双音旧版',
  duration_seconds: { opening: 4.6, ending: 4.6 },
  description: { opening: '黑场渐入，清晰停留 3 秒，再渐出至黑场。彩色标识配短提示音。', ending: '黑场渐入，清晰停留 3 秒，再渐出至黑场。彩色标识配舒缓长音。' },
  has_audio: true,
  poster_url: '/api/video-bookends/haochen-color-v2.png',
  opening_url: '/api/video-bookends/haochen-intro-v2.mp4',
  ending_url: '/api/video-bookends/haochen-outro-v2.mp4',
}, {
  id: 'haochen-black-v1',
  label: '灏尘说 · 素色静音旧版',
  duration_seconds: { opening: 4.6, ending: 4.6 },
  description: { opening: '黑场渐入，清晰停留 3 秒，再渐出至黑场。旧版静音素材。', ending: '黑场渐入，清晰停留 3 秒，再渐出至黑场。旧版静音素材。' },
  has_audio: false,
  poster_url: '/api/video-bookends/haochen-black-v1.png',
  opening_url: '/api/video-bookends/haochen-intro-v1.mp4',
  ending_url: '/api/video-bookends/haochen-outro-v1.mp4',
}] as const;

export function videoBookendPreset(id?: string) {
  if (!id) return undefined;
  const preset = VIDEO_BOOKEND_PRESETS.find(item => item.id === id);
  if (!preset) throw new Error('片头片尾预制视频不存在，请重新选择');
  return preset;
}
